@if (!!selectedMainItem().items.length) {
  <div class="selected-item">
    <sxw-svg-icon
      [class]="'icons'"
      width="16"
      height="16"
      [name]="selectedMainItem().icon"
      fillColor="var(--p-primary-color)"
      strokeColor="var(--p-primary-color)"></sxw-svg-icon>
    <span>{{ "SIDE_NAV." + selectedMainItem().label | translate }}</span>
  </div>
}

<div class="items flex-col-center">
  <ul>
    @for (subItem of selectedMainItem().items; track subItem.id) {
      <ng-container [ngTemplateOutlet]="subItems" [ngTemplateOutletContext]="{ $implicit: subItem, depth: 0 }"></ng-container>
    }
  </ul>
</div>

<!-- Render SubMenuItems and nested SubMenuItems -->
<ng-template #subItems let-subItem let-depth="depth">
  <a [routerLink]="subItem.routerLink ? subItem.routerLink : null" class="nav-item-link">
    @if (subItem.isShown) {
      <li
        class="flex-row-start nav-item"
        (click)="clickItem(subItem)"
        [class.open]="subItem.expanded"
        #rla="routerLinkActive"
        [routerLinkActive]="subItem.routerLink ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: subItem.routerLinkExact ?? false }">
        @if (subItem.icon) {
          <!-- Follow the `active` background rather than `isActive`, which is also set on ancestors of the active item. -->
          <sxw-svg-icon
            [class]="'icons'"
            width="16"
            height="16"
            [name]="subItem.icon"
            [fillColor]="rla.isActive ? 'white' : 'black'"
            [strokeColor]="rla.isActive ? 'white' : 'black'"></sxw-svg-icon>
        }
        <span>{{ "SIDE_NAV." + subItem.label | translate }}</span>
        @if (subItem?.items?.length) {
          <div class="expand-icon" [class.open]="subItem.expanded">
            <sxw-svg-icon name="down-arrow" width="10"></sxw-svg-icon>
          </div>
        }
      </li>
    }
  </a>

  @if (subItem.items.length) {
    <ul class="sub-menu sub-menu-{{ depth | json }}" [@expand-nav-item]="subItem.expanded ? 'expanded' : 'collapsed'" [class.open]="subItem.expanded">
      @for (item of subItem.items; track item.id) {
        <ng-container [ngTemplateOutlet]="subItems" [ngTemplateOutletContext]="{ $implicit: item, depth: depth + 1 }"></ng-container>
      }
    </ul>
  }
</ng-template>
